var _circle, _rect, _path, _circle2, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLastBgMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 431,
    viewBox: "0 0 848 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 265,
    r: 28,
    fill: "#8D98FF",
    fillOpacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 255.04,
    width: 24,
    height: 121,
    rx: 12,
    transform: "rotate(46 255.04 0)",
    fill: "url(#paint0_linear_4622_1426)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M835 209C837.511 214.827 842.17 219.496 848 222C842.185 224.379 837.549 228.964 835.105 234.751L835 235L834.906 234.777C832.469 228.975 827.827 224.379 822 222C827.842 219.496 832.496 214.842 835 209Z",
    fill: "#13AE67"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 412.5,
    r: 18.5,
    fill: "white",
    fillOpacity: 0.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M718.5 272C720.528 276.706 724.291 280.477 729 282.5C724.304 284.422 720.559 288.125 718.585 292.799L718.5 293L718.424 292.82C716.456 288.133 712.706 284.421 708 282.5C712.718 280.478 716.478 276.718 718.5 272Z",
    fill: "#F2F2F2",
    fillOpacity: 0.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 373C12.528 377.706 16.2914 381.477 21 383.5C16.3036 385.422 12.559 389.125 10.5848 393.799L10.5 394L10.4244 393.82C8.45592 389.133 4.70604 385.421 0 383.5C4.71827 381.478 8.47788 377.718 10.5 373Z",
    fill: "#F2F2F2",
    fillOpacity: 0.44
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4622_1426",
    x1: 267.04,
    y1: 0,
    x2: 267.04,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A6B1",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B808E",
    stopOpacity: 0.14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLastBgMiddle);
export default __webpack_public_path__ + "static/media/ic-last-bg-middle.cb5fab46c0b07822fbd2a037e6cc722d.svg";
export { ForwardRef as ReactComponent };